export default __webpack_public_path__ + "static/media/portfolio-61.0d82095a.jpg";